import Box from "@mui/material/Box";
import styled from "styled-components";

const PageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: auto;
  min-height: 100vh;
  background: #292929;
  animation: backgroundAnimation 2s infinite alternate;

  @keyframes backgroundAnimation {
    0% {
      background: #292929;
    }

    100% {
      background: #232321;
    }
  }
`;

export default PageContainer;
